import { z } from 'zod';

export const baggageDisruptionSearchSchema = z.strictObject({
  disruptionLocalId: z.string().optional().catch(undefined),
});

export type BaggageDisruptionSearch = z.output<typeof baggageDisruptionSearchSchema>;
